export default {
  picker: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
};
